import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";
import { checkForUpdate } from "./lib/appUpdate";

// 29 Sep 2026 — a home-screen app on iOS only looks for a new build on a fresh
// launch, so the crew ran stale for days. Check every 30 minutes and whenever
// the app comes back to the foreground; the PWA is autoUpdate, so a new build
// swaps in by itself. The ☰ menu also has "Update app" for a hard refresh.
if (typeof window !== "undefined") {
  window.setInterval(() => { void checkForUpdate(); }, 30 * 60_000);
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") void checkForUpdate(); });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
